import { Pipe, PipeTransform } from '@angular/core';
import { backendEnums as enumsB, frontendEnums as enumsA } from '@foxeet/domain';
import { isNil } from '@foxeet/utils/functions/javascript.functions';

/**
 * Pipe para mostrar el tipo de entidad (EntityType)
 * Oculta (retorna cadena vacía) cuando el entityType es 2 (Partner/Colaborador) o 3 (CommercialManager/Comercial)
 */
@Pipe({ name: 'entityTypeDisplay' })
export class EntityTypeDisplayPipe implements PipeTransform {
  enums = { ...enumsA, ...enumsB };

  transform(value: number, enumType: any): string {
    // Si el valor es 2 (Partner) o 3 (CommercialManager), retornar vacío
    if (value === 2 || value === 3) {
      return '';
    }
    
    // Para otros valores, usar la lógica estándar de EnumToStringPipe
    return !isNil(value) ? `${enumType}_${value}` : '';
  }
}
